module.exports = __webpack_public_path__ + "static/media/sub05.85234fac.png";